module.exports = __webpack_public_path__ + "images/emoji/no_mobile_phones.0faebc12c1d37d7a2a7a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/no_mobile_phones.png
// module id = ooQS
// module chunks = 1